import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import { Scheduling } from './scheduling';
import { SchedulingDetail } from './scheduling-detail';
import { SchedulingUpdate } from './scheduling-update';
import { SchedulingDeleteDialog } from './scheduling-delete-dialog';
import { SchedulingCancelDialog } from './scheduling-cancel-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={SchedulingUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={SchedulingUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={SchedulingDetail} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/cancel`} component={SchedulingCancelDialog} />
      <ErrorBoundaryRoute path={match.url} component={Scheduling} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={SchedulingDeleteDialog} />
  </>
);

export default Routes;
